import React from "react";
import styles from "./PropertySchufaCheck.scss";
import cx from "../utils/cx";
import Button from "./MaterialUi/Button";

export interface IPropertySchufaCheckProps {
  className?: string;
}

const PropertySchufaCheck: React.FC<React.PropsWithChildren<IPropertySchufaCheckProps>> = ({ className = '' }) => {
    return <div className={cx(styles.propertySchufaCheck, className)}>


        <div className={styles.content}>
            <h3>
                Mit dem SCHUFA-<br />
                BonitätsCheck ins neue Zuhause
            </h3>
            <div>
                <p>
                    Überzeuge deinen künftigen Vermieter von dir und mach jetzt den SCHUFA-BonitätsCheck!
                    Erhalte dein persönliches Zertifikat in nur 3&nbsp;Minuten.
                </p>

                <Button variant="outlined" data-da-einstiegsverkettung="SchufaCheck" title="zum SCHUFA-BonitätsCheck" href="https://pia.wohnglueck.de/frontend/template/wohnglueck-produkt.html?produkt=schufabonitaetscheck-wohnglueck" className="wgl-button">
                    SCHUFA-BonitätsCheck erhalten »
                </Button>

            </div>
        </div>


    </div>
};

export default PropertySchufaCheck;
